module.exports = __webpack_public_path__ + "static/media/icon_handrail.18fb54d1.svg";